var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComfortAnnotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5V13.5C0 13.7761 0.223857 14 0.5 14H2.5C2.77614 14 3 13.7761 3 13.5C3 13.2239 2.77614 13 2.5 13H1V1H2.5L2.58988 0.991944C2.82313 0.949608 3 0.74546 3 0.5C3 0.223857 2.77614 0 2.5 0H0.5L0.410124 0.00805569C0.176875 0.0503917 0 0.25454 0 0.5Z",
    fill: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13H17V1H15.5C15.2239 1 15 0.776142 15 0.5C15 0.223857 15.2239 0 15.5 0H17.5C17.7761 0 18 0.223857 18 0.5V13.5C18 13.7455 17.8231 13.9496 17.5899 13.9919L17.5 14H15.5C15.2239 14 15 13.7761 15 13.5C15 13.2545 15.1769 13.0504 15.4101 13.0081L15.5 13Z",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4629 0.310684C9.38603 0.12277 9.20316 0 9.00013 0C8.7971 0 8.61423 0.12277 8.53736 0.310684L4.03736 11.3107C3.9328 11.5663 4.05523 11.8582 4.31082 11.9628C4.5664 12.0673 4.85835 11.9449 4.9629 11.6893L6.47217 8H11.5281L13.0374 11.6893C13.1419 11.9449 13.4339 12.0673 13.6894 11.9628C13.945 11.8582 14.0675 11.5663 13.9629 11.3107L9.4629 0.310684ZM11.119 7L9.00013 1.82054L6.88126 7H11.119Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComfortAnnotation);
export default __webpack_public_path__ + "static/media/comfort-annotation.ea38b9c728a8a2236a84d342211e5c54.svg";
export { ForwardRef as ReactComponent };